export default {
  pagesLogin: {
    title1: '登录电子游戏后台',
    title2: '系统登录',
    title3: '账号',
    title4: '密码',
    title5: '验证码',
    title6: '谷歌验证码',
    title7: '平台登录',
    title8: '平台代码',
    btn: '登录',
    message1: '请填写平台代码',
    message2: '请填写账号',
    message3: '请填写密码',
    message4: '请填写谷歌验证码',
    message5: '请填写验证码',
    error1: '请输入3-8位字母或数字组合',
    error2: '请输入5~15位字母或数字组合',
    error3: '请输入6~32位字母或数字组合',
    error4: '请输入5位字母或数字组合',
    error5: '暂无访问权限',
  }
}
